"use strict";import{css as t}from"@spectrum-web-components/base";const i=t`
:host{--spectrum-accordion-item-title-padding-y:var(
--spectrum-global-dimension-size-150
);--spectrum-accordion-animation-duration:var(
--spectrum-global-animation-duration-100,0.13s
)}:host{display:block;list-style:none;margin:0;padding:0}
`;export default i;
//# sourceMappingURL=accordion.css.js.map
